import { all, takeEvery } from 'redux-saga/effects';
import {
    FETCH_LEADERBOARD_DATA,
    POLL_LEADERBOARD_DATA,
    UPDATE_NAV_ITEM
} from '../actions';
import {
    fetchLeaderboardData,
    pollMatchByMatchData
} from './fetch-leaderboard-data';
import { updateNavItem } from './update-nav-item';

/**
 *
 */
export function* leaderboardRootSaga() {
    yield all([
        takeEvery(FETCH_LEADERBOARD_DATA.REQUEST, fetchLeaderboardData),
        takeEvery(POLL_LEADERBOARD_DATA.REQUEST, pollMatchByMatchData),
        takeEvery(UPDATE_NAV_ITEM.REQUEST, updateNavItem)
    ]);
}
